<div class="w-full min-w-[300px] flex-col rounded-[16px] border-[1px] border-border bg-[#FFFFFF] shadow-sm h-auto">
    <div class="flex gap-2 items-center ml-4 mt-4">
        <h3 class="font-bold text-secondary">{{ 'dashboard.electricity_forecast_eoy' | transloco }}</h3>
        <img *ngIf="showUpgrade" src="assets/icons/lock-open.svg" class="h-[30px] w-[30px]"
            alt="{{ 'shared.lock_icon' | transloco }}">
    </div>
    <div class="mt-4 h-[1px] w-full bg-border"></div>
    @if(!showUpgrade)
    {
    <div class="m-4 flex gap-2 justify-between">
        <p class="text-neutral-500">{{ 'dashboard.total_consumption' | transloco}}:</p>
        <p class="consumptionValue font-semibold text-secondary">{{ consumptionValue !== null && consumptionValue !==
            undefined ? (consumptionValue | number:'1.0-0') : '...' }} {{ 'shared.kwh' | transloco}}</p>
    </div>
    <div class="m-4 flex justify-between">
        <p class="text-neutral-500">{{ 'dashboard.total_taxable_amount' | transloco}}:</p>
        <p class="costValue font-semibold text-secondary">{{ costValue !== null && costValue !== undefined ? (costValue
            |
            number:'1.0-0') : '...' }}€</p>
    </div>}
    @else {
    <div class="m-4 flex gap-2 justify-between items-center">
        <div class="flex flex-col gap-4">
            <p class="text-neutral-500">{{ 'dashboard.total_consumption' | transloco}}:</p>
            <p class="text-neutral-500">{{ 'dashboard.total_taxable_amount' | transloco}}:</p>
        </div>
        <div>
            <a routerLink="/settings/plans" class="text-secondary"><span class="underline font-bold">{{ 'shared.upgrade'
                    |
                    transloco}}</span> {{ 'shared.to_see_forecast_data' | transloco}}</a>
        </div>
    </div>

    }
    <!--
    Budget out of scope
    <div class="m-4 flex justify-between">
        <p class="text-neutral-500">{{ 'dashboard.budget' | transloco}}:</p>
        <p class="budgetValue font-semibold text-secondary">{{budgetValue}}€ <span
                [ngClass]="[budgetDifference < 0 ? 'text-error' : 'text-success']">
                (<span *ngIf="budgetDifference > 0">+</span>{{budgetDifference}}€)</span></p>
    </div>-->
</div>